import { useEffect, useState } from 'react';
import cn from 'classnames';
import { mediatorApi } from '@/services/chatApi';
import { getTranslation } from '@/constants/translations';
import { useLanguage } from '@/contexts/LanguageContext';
import styles from './O_MediatorSummaryCard.module.css';

/**
 * Карточка о человеке, которую медиатор собрал из его сообщений в групповых чатах.
 * Только чтение: никаких кнопок. Нужна, чтобы видеть, что сжатие чатов работает.
 */
export default function O_MediatorSummaryCard() {
  const { language } = useLanguage();
  const [summary, setSummary] = useState<string | null>(null);

  useEffect(() => {
    let isActive = true;
    mediatorApi
      .getMyMemory()
      .then(response => {
        if (isActive) setSummary(response.data?.memory?.summary || '');
      })
      .catch(() => {
        if (isActive) setSummary('');
      });
    return () => {
      isActive = false;
    };
  }, []);

  // Пока грузится — не показываем пустую карточку.
  if (summary === null) return null;

  return (
    <div className={styles.wrapper}>
      <h4 className={styles.title}>
        {getTranslation(language, 'profileTab.mediatorSummary')}
      </h4>
      {summary ? (
        <p className={cn(styles.summary, 'text-p-8')}>{summary}</p>
      ) : (
        <p className={cn(styles.empty, 'text-p-8')}>
          {getTranslation(language, 'profileTab.mediatorSummaryEmpty')}
        </p>
      )}
    </div>
  );
}
